import { RouterModule, Routes } from '@angular/router';
import { FeedbackComponent } from './common/feedback.component';
import { WelcomeComponent } from './student/interview/welcome.component';
import { RecordingResponseComponent } from './student/interview/recording-response.component';
import { ReplayResponseListComponent } from './student/interview/replay-responses.component';
import { ReviewInterviewComponent } from './student/interview/review-interview.component';
import { SampleQuestionComponent } from './student/interview/sample-question.component';
import { BeginInterviewComponent } from './student/interview/begin-interview.component';
import { EndInterviewComponent } from './student/interview/end-interview.component';
import { PracticeCompleteComponent } from './student/interview/practice-complete.component';
import { InterviewComponent } from './student/interview/interview.component';
import { InterviewCompleteComponent } from './student/interview/interview-complete.component';
import { InterviewSettingsComponent } from './student/interview/interview-settings.component';
import { ReviewerComponent } from './student/interview/reviewer.component';
import { ManagerReviewerComponent } from './manager/mgr-reviewer.component';
import { StartComponent } from './student/interview/start.component';

export const appRoutes: Routes = [
    { path: '', redirectTo: 'mock-interviews/:id', pathMatch: 'full' },
    { path: 'mock-interviews/:id', component: WelcomeComponent },
    { path: 'mock-interviews/:id/settings', component: InterviewSettingsComponent },
    { path: 'mock-interviews/:id/begin', component: BeginInterviewComponent },
    { path: 'mock-interviews/:id/end', component: EndInterviewComponent },
    { path: 'mock-interviews/:id/create', component: InterviewComponent },
    
    { path: 'mock-interviews/:id', component: StartComponent, children: [
        { path: 'response', component: RecordingResponseComponent },
        { path: 'review', component: ReviewInterviewComponent },
        { path: 'sample', component: SampleQuestionComponent },
        { path: 'practice-complete', component: PracticeCompleteComponent },
        { path: 'interview-complete', component: InterviewCompleteComponent }
    ]},
    { path: 'reviewer', component: ReviewerComponent },
    { path: 'manager-reviewer', component: ManagerReviewerComponent }
];